export default function HeroArticle({
  imgSrc,
  tagText,
  title,
  titleIcon,
  subtitle,
  body,
  meta,
  childrenBelow,
  onImageClick
}) {
  return (
    <section className="heroArticle">
      <div className="heroMedia">
        {onImageClick ? (
            <button
              type="button"
              className="heroImgBtn"
              onClick={onImageClick}
              aria-label={`Otwórz zdjęcie: ${title}`}
            >
              <img className="heroImg" src={imgSrc} alt={title} />
            </button>
          ) : (
            <img className="heroImg" src={imgSrc} alt={title} />
          )}
      <div className="heroGradient" aria-hidden="true" />
      </div>
      <div className="heroOverlayCard">
        <div className="heroTag">{tagText}</div>
        <h2 className="heroTitle">
          {title}
          {titleIcon && <span className="heroTitleIcon" aria-hidden="true">{titleIcon}</span>}
        </h2>
        {subtitle ? <div className="heroSubtitle">{subtitle}</div> : null}
        {body ? <p className="heroBody">{body}</p> : null}
        {meta ? <div className="heroMeta">{meta}</div> : null}
      </div>
      {childrenBelow ? <div className="heroBelow">{childrenBelow}</div> : null}
    </section>
  );
}